import { Fragment } from "react";

import { ContactBondLinkAnchor, ReloadAnchor } from "../Anchor";

export const retryLater = <Fragment>We’re sorry, we encountered an error on our end. Please try again later or contact <ContactBondLinkAnchor title="BondLink support" /> for help.</Fragment>;
export const refresh = <Fragment>We’re sorry, we encountered an error on our end. Try <ReloadAnchor title="refreshing the page" /> or contact <ContactBondLinkAnchor title="BondLink support" /> for help if the problem persists.</Fragment>;
export const badSession = <Fragment>We’re sorry, we encountered an error on our end. Try <ReloadAnchor title="refreshing the page" /> or try logging out and back in again.</Fragment>;
